import { Alignment, Content, TableCell } from "pdfmake/interfaces";
import svg from "../../../common/svg";

export interface ExtremeTableData {
  layerId: string;
  valueTitle: string;
  distanceTitle: string;
  maxCoordinate: string;
  minCoordinate: string;
  maxDistance: string;
  minDistance: string;
  maxValue: string;
  minValue: string;
  maxHasMultipleLocations: boolean;
  minHasMultipleLocations: boolean;
}

const cell = (text: string, alignment: Alignment = "left"): TableCell => ({
  text,
  alignment,
  margin: [4, 4, 4, 4]
});

const coordinateCell = (
  coordinate: string,
  hasMultipleLocations: boolean
): TableCell => ({
  columnGap: 2,
  columns: [
    { text: coordinate, width: "auto" },
    hasMultipleLocations
      ? {
          svg: svg.lineExtremeMultipleLocations,
          fit: [10, 10] as [number, number],
          width: 10,
          margin: [0, 1, 0, 0] as [number, number, number, number]
        }
      : { text: "", width: 0 }
  ],
  margin: [4, 4, 4, 4] as [number, number, number, number]
});

const get = (t: any, data: ExtremeTableData): Content => ({
  stack: [
    {
      table: {
        headerRows: 1,
        widths: ["*", "*", "*", "*"],
        body: [
          [
            cell(t("drawShape.Extreme Values"), "left"),
            cell(t("drawShape.Coordinates"), "left"),
            cell(data.distanceTitle, "right"),
            cell(
              data.layerId === "WS_Windspeed_Global_SwissRe"
                ? t("legend.50y Peak Gust")
                : data.valueTitle,
              "right"
            )
          ],
          [
            cell(t("drawShape.Maximum"), "left"),
            coordinateCell(data.maxCoordinate, data.maxHasMultipleLocations),
            cell(data.maxDistance, "right"),
            cell(data.maxValue, "right")
          ],
          [
            cell(t("drawShape.Minimum"), "left"),
            coordinateCell(data.minCoordinate, data.minHasMultipleLocations),
            cell(data.minDistance, "right"),
            cell(data.minValue, "right")
          ]
        ]
      },
      layout: {
        hLineWidth: () => 1,
        vLineWidth: (i: number) => (i === 0 || i === 4 ? 1 : 0),
        hLineColor: () => "#E4E4E4",
        vLineColor: () => "#E4E4E4",
        paddingTop: () => 0,
        paddingBottom: () => 0
      },
      fontSize: 8,
      opacity: 0.87
    },
    ...(data.maxHasMultipleLocations || data.minHasMultipleLocations
      ? [
          {
            columns: [
              {
                svg: svg.lineExtremeMultipleLocations,
                fit: [10, 10] as [number, number],
                width: 10,
                margin: [0, 0, 4, 0] as [number, number, number, number]
              },
              {
                text: t("drawShape.Multiple Locations Icon Description")
              }
            ],
            fontSize: 8,
            opacity: 0.87,
            margin: [0, 6, 0, 0] as [number, number, number, number]
          }
        ]
      : [])
  ],
  unbreakable: true
});

export default get;
